/*
  Flou Family — performance defer helper
  ----------------------------------------------------------------------
  Loads heavy third-party scripts (Shiprocket, marketing) only after
  the user interacts with the page or the browser goes idle. This keeps
  them off the critical path during initial paint, which reduces
  Total Blocking Time (TBT) dramatically.

  Usage from Liquid:

    <script src="{{ 'ff-perf-defer.js' | asset_url }}" defer></script>
    <script>
      window.FFDefer = window.FFDefer || { queue: [] };
      FFDefer.queue.push({
        src: 'https://fastrr-boost-ui.pickrr.com/.../shopify.js',
        attrs: { defer: true }
      });
    </script>

  Trigger order:
    1. First user interaction (scroll / pointermove / touchstart / keydown)
    2. OR requestIdleCallback after 2s
    3. OR hard fallback after 4s
  Whichever fires first.
*/

(function () {
  'use strict';

  var loaded = false;
  var queue = (window.FFDefer && window.FFDefer.queue) || [];

  function loadOne(item) {
    return new Promise(function (resolve) {
      // Skip if already injected
      if (item.src && document.querySelector('script[src="' + item.src + '"]')) {
        return resolve();
      }
      var s = document.createElement('script');
      if (item.src) s.src = item.src;
      if (item.attrs) {
        for (var k in item.attrs) {
          if (item.attrs[k] === true) s.setAttribute(k, '');
          else if (item.attrs[k] !== false) s.setAttribute(k, item.attrs[k]);
        }
      }
      if (item.text) s.text = item.text;
      s.onload = s.onerror = resolve;
      document.head.appendChild(s);
    });
  }

  function flush() {
    if (loaded) return;
    loaded = true;

    // Drain anything queued so far
    var items = queue.slice(0);
    queue.length = 0;

    // Replace queue with an immediate-load version for late pushes
    window.FFDefer = {
      queue: {
        push: function (item) { loadOne(item); }
      },
      ready: true
    };

    items.reduce(function (chain, item) {
      return chain.then(function () { return loadOne(item); });
    }, Promise.resolve()).then(function () {
      // Notify listeners that deferred scripts are loaded
      document.dispatchEvent(new CustomEvent('ff:deferred-loaded'));
    });
  }

  // Trigger 1: any user interaction
  var INTERACTIONS = ['pointerdown', 'pointermove', 'touchstart', 'keydown', 'scroll', 'wheel'];
  function onInteract() {
    INTERACTIONS.forEach(function (ev) {
      window.removeEventListener(ev, onInteract, { passive: true, capture: true });
    });
    flush();
  }
  INTERACTIONS.forEach(function (ev) {
    window.addEventListener(ev, onInteract, { passive: true, capture: true });
  });

  // Trigger 2: idle callback after 2s
  function onIdle() {
    var fn = window.requestIdleCallback || function (cb) { return setTimeout(cb, 200); };
    fn(flush, { timeout: 4000 });
  }
  setTimeout(onIdle, 2000);

  // Trigger 3: hard fallback at 4s — guarantees scripts eventually run
  setTimeout(flush, 4000);
})();
